import currentUser from './slices';

const teamProfileReducer = currentUser.reducer;

export default teamProfileReducer;
